import React, { PureComponent } from "react";
import { withRouter } from "react-router";
import queryString from "query-string-for-all";
import styled from "styled-components";
import {
  Center,
  Left,
  PrimaryNav as BlocksPrimaryNav,
  Right,
  Thirds,
  color,
} from "@conserveit/blocks";
import ConnectedSiteMenu from "../../containers/SiteMenu";
import UserMenu from "./components/UserMenu";
import { PrimaryNav } from "./components/PrimaryNav";
import { getClientRoutes } from "./getClientRoutes";

const Chrome = styled.div`
  min-width: 1024px;
  color: ${color.theme.typography.ink};
`;

class AppChrome extends PureComponent {
  updateQSSites = (selectedSites) => {
    const { history } = this.props;
    const qs = queryString.parse(history.location.search);
    const sites = selectedSites.join(",");
    const stringified = queryString.stringify({ ...qs, sites });
    history.replace({ search: stringified });
  };

  render() {
    const { user, appReady } = this.props;
    const clientRoutes = getClientRoutes(
      user || { token: undefined, access: [] }
    );
    const { appLinks } = clientRoutes;

    return (
      <Chrome>
        {appReady && (
          <BlocksPrimaryNav>
            <Thirds>
              <Left>
                {user && (
                  <ConnectedSiteMenu onSitesUpdate={this.updateQSSites} />
                )}
              </Left>
              <Center>
                {appLinks.length > 0 && <PrimaryNav links={appLinks} />}
              </Center>
              <Right>
                <UserMenu
                  className="UserMenu"
                  clientRoutes={clientRoutes}
                  loggedIn={appReady}
                />
              </Right>
            </Thirds>
          </BlocksPrimaryNav>
        )}
      </Chrome>
    );
  }
}

export default withRouter(AppChrome);
